import React from 'react';
import ga from 'react-ga';

class GoogleAnalytics extends React.Component {
  componentDidMount() {
    ga.initialize('UA-135148027-3');
    ga.pageview(this.props.location.pathname);
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      ga.pageview(this.props.location.pathname);
    }
  }
  render() {
    return null;
  }
}

export default GoogleAnalytics;



// WEBPACK FOOTER //
// ./src/Components/GA/index.js